import { render, staticRenderFns } from "./source_batch_page.vue?vue&type=template&id=c63acb84&scoped=true"
import script from "./source_batch_page.vue?vue&type=script&lang=js"
export * from "./source_batch_page.vue?vue&type=script&lang=js"
import style0 from "./source_batch_page.vue?vue&type=style&index=0&id=c63acb84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63acb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63acb84')) {
      api.createRecord('c63acb84', component.options)
    } else {
      api.reload('c63acb84', component.options)
    }
    module.hot.accept("./source_batch_page.vue?vue&type=template&id=c63acb84&scoped=true", function () {
      api.rerender('c63acb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/source_batch_page.vue"
export default component.exports